import React, { useState, useEffect } from "react";
import { usePage, Link } from "@inertiajs/react";
import FlashMessages from "../Shared/FlashMessages";
import UidMigrationWizard from "../../../Components/UidMigrationWizard";

export default function Continue({ participant }) {
  const { user } = usePage().props;
  const { flash, errors } = usePage().props;
  const [clearHistory, setClearHistory] = useState(false);
  const [showUidMigrationWizard, setShowUidMigrationWizard] = useState(false);
  const displayId =
    participant?.new_participant_uid ||
    participant?.participant_uid ||
    user.is.currently_seeing;
  const wizardOpen =
    Boolean(participant?.needs_uid_migration) && showUidMigrationWizard;

  useEffect(() => {
    if (!clearHistory) {
      history.pushState(window.history.state, "", window.location.href);
      setClearHistory(true);
    }

    return () => {};
  }, []);

  function closeUidMigrationWizard() {
    setShowUidMigrationWizard(false);
  }
  return (
    <div className="bg-gray-100 min-h-screen w-full flex items-center justify-center">
      <FlashMessages />
      <div className=" mt-8flex flex-col flex-wrap w-full bg-white shadow-md p-8 md:p-16 container mx-auto max-w-xs md:max-w-lg">
        <h5 className="mb-4 text-2xl text-gray-700 font-semibold ">
          Continue with {displayId}
        </h5>
        {participant?.needs_uid_migration && !showUidMigrationWizard && (
          <button
            type="button"
            className="mb-6 w-full bg-customOrange hover:bg-customOrange/80 text-white cursor-pointer p-4 text-left"
            onClick={() => setShowUidMigrationWizard(true)}
          >
            <p className="font-semibold text-white">
              Participant needs ID migration
            </p>
            <p className="mt-1 text-sm text-white">
              Old ID: {participant.participant_uid}
            </p>
            <p className="mt-1 text-sm text-white">
              Optional — you can still start a form below.
            </p>
          </button>
        )}

        {wizardOpen && (
          <UidMigrationWizard
            participant={participant}
            onCancel={closeUidMigrationWizard}
            onComplete={closeUidMigrationWizard}
          />
        )}
        {!wizardOpen && (
          <>
            <div className="flex flex-row flex-wrap justify-center divide-y-8">
              {flash.referredPage !== "exchange" && (
                <Link
                  href="/exchange/show1"
                  className="p-4 bg-customBlue hover:bg-customBlue/80 cursor-pointer text-white flex-grow w-full text-center"
                >
                  Start a new Syringe/Harm Reduction Service
                </Link>
              )}
              {flash.referredPage !== "dropin" && (
                <Link
                  href="/dropin/create"
                  className="p-4 bg-customBlue hover:bg-customBlue/80 cursor-pointer text-white flex-grow w-full text-center"
                >
                  Start a new Drop In / Outreach
                </Link>
              )}
              {flash.referredPage !== "naloxone" && (
                <Link
                  href="/narcan/create"
                  className="p-4 bg-customBlue hover:bg-customBlue/80 cursor-pointer text-white flex-grow w-full text-center"
                >
                  Start a new Naloxone/Narcan Recipient Form
                </Link>
              )}
              {flash.referredPage !== "holistic" && (
                <Link
                  href="/holistic/create"
                  className="p-4 bg-customBlue hover:bg-customBlue/80 cursor-pointer text-white flex-grow w-full text-center"
                >
                  Start a new Holistic Services Form
                </Link>
              )}
              {flash.referredPage !== "smokingKit" && (
                <Link
                  href="/smokingkit/create"
                  className="p-4 bg-customBlue hover:bg-customBlue/80 cursor-pointer text-white flex-grow w-full text-center"
                >
                  Start a new Smoking Kit Form
                </Link>
              )}
              {flash.referredPage !== "vaccineService" && (
                <Link
                  href="/vaccineservice/create"
                  className="p-4 bg-customBlue hover:bg-customBlue/80 cursor-pointer text-white flex-grow w-full text-center"
                >
                  Start a new Vaccine Service Form
                </Link>
              )}
              {flash.referredPage !== "respite" && (
                <Link
                  href="/respite/create"
                  className="p-4 bg-customBlue hover:bg-customBlue/80 cursor-pointer text-white flex-grow w-full text-center"
                >
                  Start a new Respite Service Form
                </Link>
              )}
            </div>

            <h5 className="mb-4 text-2xl text-gray-700 font-semibold mt-8">
              Finish with {displayId}
            </h5>
            <div className="flex flex-row flex-wrap justify-center">
              <Link
                method="POST"
                href="/participants/drop"
                className="p-4 bg-gray-100 hover:bg-gray-200 cursor-pointer flex-grow w-full text-center"
              >
                Finish and clear current participant
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
